export default {
    props: {
        eventBus: {
            type: Vue,
            required: true
        },
        filterKey: {
            type: String,
            required: true
        }
    }
}